var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-bathroom",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4228",
    "data-name": "Rectangle 4228",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shower_FILL1_wght400_GRAD0_opsz24",
    d: "M203.357,232.784a1.1,1.1,0,1,1,.8-.322A1.083,1.083,0,0,1,203.357,232.784Zm4.476,0a1.1,1.1,0,1,1,.8-.322A1.083,1.083,0,0,1,207.832,232.784Zm4.476,0a1.1,1.1,0,1,1,.8-.322A1.083,1.083,0,0,1,212.308,232.784Zm-11.189-4.476A1.1,1.1,0,0,1,200,227.189V226.07a7.709,7.709,0,0,1,6.714-7.721v-1.231a1.119,1.119,0,1,1,2.238,0v1.231a7.709,7.709,0,0,1,6.713,7.721v1.119a1.1,1.1,0,0,1-1.119,1.119Zm2.238,7.832a1.1,1.1,0,1,1,.8-.322A1.083,1.083,0,0,1,203.357,236.14Zm4.476,0a1.1,1.1,0,1,1,.8-.322A1.083,1.083,0,0,1,207.832,236.14Zm4.476,0a1.1,1.1,0,1,1,.8-.322A1.083,1.083,0,0,1,212.308,236.14Z",
    transform: "translate(-195.831 -214.152)",
    fill: "#357bfc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShower);
export default __webpack_public_path__ + "static/media/icon-shower.d93525dc58a5c38f1f138527cc726ef1.svg";
export { ForwardRef as ReactComponent };